import * as React from "react";
import { BehaviorSubject } from "rxjs";
import { Locale } from "../../../locale";

const LocaleContext = React.createContext<{
  localeObservable: BehaviorSubject<Locale>;
  defaultLocale: Locale;
} | null>(null);
export default LocaleContext;
